/* Sydney Aero Parts 2026 rebuild: theme behaviour. Original code, written for SAP. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionOn = function () { return root.classList.contains('sap-motion') && !reduce.matches; };
  var SAP = (window.SAP = window.SAP || {});
  var qa = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };

  /* ---------------- scroll loop (one rAF for everything scroll-driven) ---------------- */
  var scrollFns = [];
  var ticking = false;
  function runScroll() { ticking = false; for (var i = 0; i < scrollFns.length; i++) scrollFns[i](); }
  function requestScroll() { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll);
  SAP.onScroll = function (fn) { scrollFns.push(fn); requestScroll(); };
  SAP.progress = function (el) {
    // 0 when the element's top reaches the viewport top, 1 when its bottom reaches the viewport bottom
    var r = el.getBoundingClientRect();
    var span = r.height - window.innerHeight;
    if (span <= 0) return r.top <= 0 ? 1 : 0;
    return Math.min(1, Math.max(0, -r.top / span));
  };

  /* ---------------- reveal + split words ---------------- */
  function splitWords(el) {
    if (el.classList.contains('sap-split')) return;
    var i = 0;
    (function walk(node) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (k) {
        if (k.nodeType === 3) {
          var parts = k.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'sap-w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          node.replaceChild(frag, k);
        } else if (k.nodeType === 1 && k.tagName !== 'BR' && !(k.namespaceURI && k.namespaceURI.indexOf('svg') > -1)) {
          walk(k);
        }
      });
    })(el);
    el.classList.add('sap-split');
  }
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  var circleIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-drawn'); circleIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.6 }) : null;
  function initCircles(scope) {
    qa('[data-sap-fx]', scope).forEach(function (el) {
      if (!motionOn() || !circleIO || (window.Shopify && Shopify.designMode)) { el.classList.add('is-drawn'); return; }
      circleIO.observe(el);
    });
  }
  function initReveal(scope) {
    var motion = motionOn();
    qa('[data-sap-words]', scope).forEach(function (el) {
      if (motion) splitWords(el);
      if (motion && el.hasAttribute('data-sap-mask') && !el.classList.contains('sap-masklines')) {
        // group words into visual lines (by rendered top) so each line rises together, staggered line by line
        var ws = qa('.sap-w', el), tops = [];
        ws.forEach(function (w) { var t = Math.round(w.getBoundingClientRect().top); if (!tops.some(function (x) { return Math.abs(x - t) < 6; })) tops.push(t); });
        tops.sort(function (a, b) { return a - b; });
        ws.forEach(function (w) {
          var t = Math.round(w.getBoundingClientRect().top), li = 0;
          tops.forEach(function (x, n) { if (Math.abs(x - t) < 6) li = n; });
          w.firstChild.style.setProperty('--i', li * 2);
        });
        el.classList.add('sap-masklines');
      }
      if (el.dataset.sapDelay) el.style.setProperty('--sap-delay', el.dataset.sapDelay + 'ms');
    });
    qa('[data-sap-stagger]', scope).forEach(function (el) {
      Array.prototype.forEach.call(el.children, function (c, n) { c.style.setProperty('--i', Math.min(n, 8)); });
    });
    qa('[data-sap-reveal],[data-sap-words],[data-sap-stagger]', scope).forEach(function (el) {
      if (el.dataset.sapDelay) el.style.setProperty('--sap-delay', el.dataset.sapDelay + 'ms');
      if (!motion || !revealIO || window.Shopify && Shopify.designMode) { el.classList.add('is-in'); return; }
      revealIO.observe(el);
    });
    qa('img.sap-fade', scope).forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      else {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
      }
    });
  }

  /* ---------------- parallax ---------------- */
  var parallaxEls = [];
  function initParallax(scope) {
    if (!motionOn()) return;
    qa('[data-sap-parallax]', scope).forEach(function (el) { if (parallaxEls.indexOf(el) < 0) parallaxEls.push(el); });
  }
  SAP.onScroll(function () {
    if (!parallaxEls.length || !motionOn()) return;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var host = el.parentElement || el;
      var r = host.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var min = parseInt(el.dataset.sapParallaxMin, 10) || 0;
      if (window.innerWidth < min) { el.style.transform = ''; return; }
      var f = parseFloat(el.dataset.sapParallax) || 0.1;
      var d = (r.top + r.height / 2 - vh / 2) * -f;
      el.style.transform = 'translate3d(0,' + d.toFixed(1) + 'px,0)';
    });
  });

  /* ---------------- drawers ---------------- */
  var lastFocus = null;
  function openDrawer(d, trigger) {
    if (!d) return;
    lastFocus = trigger || document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () {
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      root.classList.add('sap-lock');
      var f = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    });
    qa('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(d) {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    root.classList.remove('sap-lock');
    qa('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  SAP.openDrawer = openDrawer; SAP.closeDrawer = closeDrawer;
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sap-open]');
    if (open) { e.preventDefault(); openDrawer(document.getElementById(open.getAttribute('data-sap-open')), open); return; }
    var close = e.target.closest('[data-sap-close]');
    if (close) { e.preventDefault(); closeDrawer(close.closest('.sap-drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qa('.sap-drawer.is-open').forEach(closeDrawer);
    qa('.sap-nav__item.is-open').forEach(function (i) { setMega(i, false); });
  });

  /* ---------------- header ---------------- */
  function setMega(item, open) {
    item.classList.toggle('is-open', open);
    var b = item.querySelector('[aria-expanded]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function initHeader(scope) {
    var section = (scope || document).querySelector('.sap-header-section') || document.querySelector('.sap-header-section');
    if (!section || section.dataset.sapInit) return;
    section.dataset.sapInit = '1';
    var header = section.querySelector('.sap-header');
    var sticky = header && header.dataset.sticky !== 'false';
    var lastY = window.scrollY;
    SAP.onScroll(function () {
      var y = window.scrollY;
      section.classList.toggle('is-scrolled', y > 4);
      if (sticky) {
        var h = section.offsetHeight;
        var anyOpen = section.querySelector('.sap-nav__item.is-open');
        if (y > lastY && y > h + 40 && !anyOpen) section.classList.add('is-hidden');
        else if (y < lastY - 2 || y <= h) section.classList.remove('is-hidden');
      }
      var hh = section.offsetHeight;
      root.style.setProperty('--sap-hh', hh + 'px');
      root.style.setProperty('--sap-sticky-top', section.classList.contains('is-hidden') ? '0px' : hh + 'px');
      lastY = y;
    });
    // mega menu: hover intent + click/keyboard
    qa('.sap-nav__item[data-mega]', section).forEach(function (item) {
      var t = null;
      var btn = item.querySelector('.sap-nav__toggle');
      item.addEventListener('mouseenter', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          qa('.sap-nav__item.is-open', section).forEach(function (o) { if (o !== item) setMega(o, false); });
          setMega(item, true);
        }, 90);
      });
      item.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { setMega(item, false); }, 160); });
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = !item.classList.contains('is-open');
        qa('.sap-nav__item.is-open', section).forEach(function (o) { setMega(o, false); });
        setMega(item, willOpen);
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) setMega(item, false); });
    });
    // predictive search
    var form = document.querySelector('[data-sap-search]');
    if (form) initSearch(form);
  }

  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  SAP.money = money;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  SAP.esc = esc;
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  SAP.sized = sized;

  function initSearch(form) {
    var input = form.querySelector('input[type="search"]');
    var out = document.querySelector('[data-sap-search-results]');
    var idle = document.querySelector('[data-sap-search-idle]');
    if (!input || !out) return;
    var timer = null, ctrl = null;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; if (idle) idle.hidden = false; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        var url = (window.routes && routes.predictive_search_url ? routes.predictive_search_url : '/search/suggest') +
          '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
          var res = (d && d.resources && d.resources.results) || {};
          var html = '';
          if (res.collections && res.collections.length) {
            html += '<h3>' + esc(out.dataset.lCollections) + '</h3><div class="sap-search-suggest" style="margin-bottom:22px">';
            res.collections.forEach(function (c) { html += '<a class="sap-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
            html += '</div>';
          }
          if (res.products && res.products.length) {
            html += '<h3>' + esc(out.dataset.lProducts) + '</h3><ul>';
            res.products.forEach(function (p) {
              html += '<li><a class="sap-sr" href="' + esc(p.url) + '">' +
                (p.featured_image && p.featured_image.url ? '<img src="' + esc(sized(p.featured_image.url, 160)) + '" alt="" width="64" height="80" loading="lazy">' : '<span></span>') +
                '<div><strong>' + esc(p.title) + '</strong><span>' + esc(money(Math.round(parseFloat(p.price) * 100))) + '</span></div></a></li>';
            });
            html += '</ul>';
          }
          if (!html) html = '<p>' + esc(out.dataset.lEmpty) + ' &ldquo;' + esc(q) + '&rdquo;</p>';
          html += '<a class="sap-btn sap-btn--sm" href="' + esc(form.getAttribute('action')) + '?q=' + encodeURIComponent(q) + '&type=product">' + esc(out.dataset.lAll) + '</a>';
          out.innerHTML = html;
          if (idle) idle.hidden = true;
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------------- announcement ---------------- */
  function applyGates(scope) {
    var now = Date.now() / 1000;
    qa('[data-sap-gate]', scope).forEach(function (el) {
      var ts = parseFloat(el.dataset.sapTs) || 0, g = el.dataset.sapGate;
      el.hidden = g === 'before' ? now >= ts : g === 'after' ? now < ts : false;
    });
  }
  SAP.applyGates = applyGates;
  function initAnnounce(scope) {
    qa('[data-sap-announce]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var msgs = qa('.sap-announce__msg:not([hidden])', el);
      if (!msgs.length) return;
      var idx = 0, timer = null, speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
      function show(n) {
        idx = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, i) { m.classList.toggle('is-active', i === idx); m.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
      }
      function play() { stop(); if (msgs.length > 1 && !reduce.matches) timer = setInterval(function () { show(idx + 1); }, speed); }
      function stop() { clearInterval(timer); }
      show(0); play();
      var p = el.querySelector('.sap-prev'), n = el.querySelector('.sap-next');
      if (p) p.addEventListener('click', function () { show(idx - 1); play(); });
      if (n) n.addEventListener('click', function () { show(idx + 1); play(); });
      el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', play);
      el.addEventListener('focusin', stop); el.addEventListener('focusout', play);
    });
  }

  /* ---------------- sliders ---------------- */
  function initSliders(scope) {
    qa('[data-sap-slider]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
      function track() { return el.querySelector('.sap-track:not([hidden])') || el.querySelector('.sap-panel:not([hidden]) .sap-track'); }
      function step() { var t = track(); var c = t && t.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 16) : 300; }
      function update() {
        var t = track(); if (!t || !prev || !next) return;
        var max = t.scrollWidth - t.clientWidth - 2;
        prev.disabled = t.scrollLeft <= 2; next.disabled = t.scrollLeft >= max;
        var nav = prev.closest('.sap-slider-nav');
        if (nav) nav.style.visibility = max <= 2 ? 'hidden' : '';
      }
      if (prev) prev.addEventListener('click', function () { var t = track(); t && t.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { var t = track(); t && t.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      qa('.sap-track', el).forEach(function (t) { t.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true }); });
      window.addEventListener('resize', update);
      el.sapUpdate = update;
      update();
    });
  }

  /* ---------------- tabs ---------------- */
  function initTabs(scope) {
    qa('[data-sap-tabs]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var tabs = qa('[role="tab"]', el), panels = qa('[role="tabpanel"]', el);
      function select(i, focus) {
        tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; t.classList.toggle('is-active', n === i); });
        panels.forEach(function (p, n) {
          p.hidden = n !== i;
          if (n === i) { p.classList.remove('is-in'); requestAnimationFrame(function () { p.classList.add('is-in'); }); var tr = p.querySelector('.sap-track'); if (tr) tr.scrollLeft = 0; }
        });
        if (focus) tabs[i].focus();
        if (el.sapUpdate) el.sapUpdate();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
          if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
        });
      });
    });
  }

  /* ---------------- slideshow ---------------- */
  function initSlideshow(scope) {
    qa('[data-sap-slideshow]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var slides = qa('.sap-slide', el), texts = qa('.sap-slide-text', el), dots = qa('.sap-dots button', el);
      if (!slides.length) return;
      var idx = 0, timer = null, speed = (parseInt(el.dataset.speed, 10) || 5) * 1000, paused = false;
      var toggle = el.querySelector('[data-pause]');
      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
        texts.forEach(function (s, i) {
          s.classList.toggle('is-active', i === idx);
          s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          qa('a', s).forEach(function (a) { a.tabIndex = i === idx ? 0 : -1; });
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        el.style.setProperty('--sap-slide-dur', speed + 'ms');
      }
      function play() { clearInterval(timer); if (!paused && slides.length > 1 && !reduce.matches && el.dataset.autoplay === 'true') timer = setInterval(function () { show(idx + 1); }, speed); }
      el.classList.add('is-ready');
      show(0); play();
      dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); play(); }); });
      var p = el.querySelector('[data-prev]'), n = el.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { show(idx - 1); play(); });
      if (n) n.addEventListener('click', function () { show(idx + 1); play(); });
      if (toggle) {
        if (reduce.matches || el.dataset.autoplay !== 'true') toggle.hidden = true;
        toggle.addEventListener('click', function () {
          paused = !paused; toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          toggle.setAttribute('aria-label', paused ? toggle.dataset.lPlay : toggle.dataset.lPause);
          el.classList.toggle('is-paused', paused); play();
        });
      }
      // swipe
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) { show(idx + (dx < 0 ? 1 : -1)); play(); }
      });
    });
  }

  /* ---------------- sticky video ---------------- */
  function initStickyVideo(scope) {
    qa('[data-sap-sticky-video]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var video = el.querySelector('video');
      var btn = el.querySelector('[data-video-toggle]');
      var userPaused = reduce.matches;
      if (video) {
        video.muted = true; video.playsInline = true; video.setAttribute('playsinline', '');
        video.removeAttribute('controls');
        if (reduce.matches) { video.removeAttribute('autoplay'); video.pause(); }
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (e.isIntersecting && !userPaused) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else if (!e.isIntersecting) video.pause();
          });
        }, { threshold: 0.05 });
        io.observe(el);
        function sync() { if (btn) { var playing = !video.paused; btn.setAttribute('aria-label', playing ? btn.dataset.lPause : btn.dataset.lPlay); btn.classList.toggle('is-paused', !playing); } }
        video.addEventListener('play', sync); video.addEventListener('pause', sync); sync();
        if (btn) btn.addEventListener('click', function () {
          if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); }
        });
      }
      var overlay = el.querySelector('.sap-sv__overlay');
      var from = parseFloat(el.dataset.overlayFrom || '0.7'), to = parseFloat(el.dataset.overlayTo || '0.25');
      if (overlay && motionOn()) SAP.onScroll(function () {
        var p = SAP.progress(el);
        overlay.style.opacity = (from + (to - from) * Math.min(1, p * 1.6)).toFixed(3);
      });
    });
  }

  /* ---------------- layered image banner (scroll-driven) ---------------- */
  function initLayers(scope) {
    qa('[data-sap-layers]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      if (!motionOn()) return;
      el.classList.add('is-driven');
      var layers = qa('.sap-layer', el);
      var n = layers.length;
      if (n < 2) return;
      SAP.onScroll(function () {
        var p = SAP.progress(el);
        var seg = 1 / (n - 1);
        layers.forEach(function (l, i) {
          if (i === 0) { l.style.transform = 'scale(' + (1.08 - 0.08 * Math.min(1, p * 2)).toFixed(4) + ')'; return; }
          var local = Math.min(1, Math.max(0, (p - (i - 1) * seg) / seg));
          var e = 1 - Math.pow(1 - local, 3);
          l.style.clipPath = 'inset(' + ((1 - e) * 100).toFixed(2) + '% 0 0 0 round var(--sap-radius))';
          l.firstElementChild && (l.firstElementChild.style.transform = 'scale(' + (1.15 - 0.15 * e).toFixed(4) + ')');
        });
        var counter = el.querySelector('[data-layer-count]');
        if (counter) counter.textContent = String(Math.min(n, 1 + Math.floor(p * (n - 1) + 0.5)));
      });
    });
  }

  /* ---------------- hotspots ---------------- */
  function initHotspots(scope) {
    qa('[data-sap-look]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var spots = qa('.sap-spot', el);
      spots.forEach(function (s) {
        var b = s.querySelector('button');
        b.addEventListener('click', function () {
          var open = !s.classList.contains('is-open');
          spots.forEach(function (o) { o.classList.remove('is-open'); o.querySelector('button').setAttribute('aria-expanded', 'false'); });
          s.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
          var target = el.querySelector('[data-look-card="' + s.dataset.spot + '"]');
          if (target && open) {
            var tr = target.closest('.sap-track');
            if (tr) tr.scrollTo({ left: target.offsetLeft - tr.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
            qa('[data-look-card]', el).forEach(function (c) { c.classList.toggle('is-active', c === target); });
          }
        });
      });
      document.addEventListener('click', function (e) { if (!el.contains(e.target)) spots.forEach(function (o) { o.classList.remove('is-open'); o.querySelector('button').setAttribute('aria-expanded', 'false'); }); });
    });
  }

  /* ---------------- marquee: pause off-screen ---------------- */
  function initMarquee(scope) {
    qa('[data-sap-marquee]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) { en.forEach(function (e) { el.classList.toggle('is-offscreen', !e.isIntersecting); }); }).observe(el);
      if (motionOn() && el.dataset.scrollShift) {
        var inner = el.querySelector('.sap-marquee__shift');
        var f = parseFloat(el.dataset.scrollShift) || 0.15;
        if (inner) SAP.onScroll(function () {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          inner.style.transform = 'translate3d(' + ((r.top - window.innerHeight / 2) * f).toFixed(1) + 'px,0,0)';
        });
      }
    });
  }

  /* ---------------- recently viewed (product + collection pages) ---------------- */
  var RV_KEY = 'sap-recently-viewed';
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]') || []; } catch (e) { return []; } }
  SAP.rvPush = function (handle) {
    if (!handle) return;
    try {
      var list = rvRead().filter(function (h) { return h !== handle; });
      list.unshift(handle); localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  };
  SAP.cardHTML = function (p) {
    var img = p.featured_image || (p.images && p.images[0]);
    var price = money(p.price) ;
    var L = SAP.strings || {};
    var from = p.price_varies ? (L.from || 'From') + ' ' : '';
    var sold = p.available === false;
    return '<div class="sap-card">' +
      '<a class="sap-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + esc(sized(img, 700)) + '" srcset="' + esc(sized(img, 400)) + ' 400w, ' + esc(sized(img, 700)) + ' 700w" sizes="(min-width: 990px) 20vw, 60vw" alt="" loading="lazy" width="700" height="875">' : '') +
      (sold ? '<span class="sap-card__badges"><span class="sap-badge">' + esc(L.soldOut || 'Sold out') + '</span></span>' : '') +
      '</a>' +
      '<p class="sap-card__caption">' + esc(p.type || p.vendor || '') + '</p>' +
      '<div class="sap-card__row"><h3 class="sap-card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      '<span class="sap-card__price">' + esc(from) + esc(price) + '</span></div></div>';
  };
  function initRecent(scope) {
    qa('[data-sap-recent]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var current = el.dataset.current || '';
      var limit = parseInt(el.dataset.limit, 10) || 8;
      var handles = rvRead().filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (!handles.length) return;
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) return;
        var track = el.querySelector('.sap-track');
        track.innerHTML = items.map(function (p) { return '<li>' + SAP.cardHTML(p) + '</li>'; }).join('');
        el.hidden = false;
        initSliders(el.parentElement);
        if (el.sapUpdate) el.sapUpdate();
      });
    });
  }

  /* ---------------- product recommendations (related) ---------------- */
  function initRecs(scope) {
    qa('[data-sap-recs]', scope).forEach(function (el) {
      if (el.dataset.sapInit) return; el.dataset.sapInit = '1';
      var url = el.dataset.url;
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-sap-recs]');
        if (fresh && fresh.querySelector('.sap-track li')) {
          el.innerHTML = fresh.innerHTML; el.hidden = false;
          initReveal(el); initSliders(el);
        }
      }).catch(function () {});
    });
  }

  /* ---------------- add to cart (shared by product form, quick add) ---------------- */
  SAP.addToCart = function (items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    return fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      var busy = 'The cart is busy right now. Try again in a moment.';
      return r.text().then(function (t) {
        var j; try { j = JSON.parse(t); } catch (e) { throw new Error(r.status === 429 ? busy : 'That could not be added. Try again in a moment.'); }
        return { ok: r.ok, j: j };
      });
    }).then(function (res) {
      if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'That could not be added.');
      if (drawer && typeof drawer.renderContents === 'function') {
        res.j.id = items[0].id; drawer.renderContents(res.j); drawer.classList.remove('is-empty');
      } else if (!/\/cart/.test(window.location.pathname)) {
        window.location.href = (window.routes && routes.cart_url) || '/cart';
      } else { window.location.reload(); }
      return res.j;
    });
  };
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-sap-quick-add]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    var id = parseInt(f.querySelector('[name="id"]').value, 10);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    SAP.addToCart([{ id: id, quantity: 1 }]).catch(function (err) {
      var m = f.querySelector('.sap-qa-err') || f.appendChild(Object.assign(document.createElement('p'), { className: 'sap-qa-err', role: 'alert' }));
      m.textContent = err.message;
    }).then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------------- multi-buy progress (reads Shopify's own discount allocations from /cart.js) ---------------- */
  var UNITS = { tees: ['tee', 'tees'], hoodies: ['hoodie', 'hoodies'], six: ['item', 'items'] };
  function dealCounts(cart) {
    var c = {};
    (SAP.deals || []).forEach(function (d) {
      c[d.key] = cart.items.reduce(function (n, it) { return n + (d.types.indexOf(it.product_type) > -1 ? it.quantity : 0); }, 0);
    });
    return c;
  }
  function savingsByTitle(cart) {
    var s = {};
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title; if (!t) return;
        s[t] = (s[t] || 0) + a.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { s[a.title] = (s[a.title] || 0) + a.total_allocated_amount; });
    return s;
  }
  function fillDeals(el, cart) {
    var deals = {}; (SAP.deals || []).forEach(function (d) { deals[d.key] = d; });
    if (!deals.six) { el.hidden = true; return; }
    var cnt = dealCounts(cart), save = savingsByTitle(cart), rows = [], shown = 0;
    function row(d, done, msg, frac) {
      var amt = save[d.title]; if (done && amt) shown += amt;
      rows.push('<li class="sap-dp' + (done ? ' is-done' : '') + '"><span class="sap-dp__pct">' + d.pct + '%</span><div class="sap-dp__body"><strong>' + esc(msg) + '</strong>' +
        (done && amt ? '<span class="sap-dp__save">Saving ' + esc(money(amt)) + '</span>' : '') +
        '<span class="sap-dp__bar" aria-hidden="true"><i style="width:' + Math.round(Math.min(1, frac) * 100) + '%"></i></span></div></li>');
    }
    var six = deals.six, n = cnt.six || 0;
    if (n >= six.min) row(six, true, six.title + ': applied', 1);
    else {
      ['tees', 'hoodies'].forEach(function (k) {
        var d = deals[k], c = cnt[k] || 0; if (!d || c <= 0) return;
        if (c >= d.min) row(d, true, d.title + ': applied', 1);
        else { var left = d.min - c; row(d, false, 'Add ' + left + ' more ' + UNITS[k][left === 1 ? 0 : 1] + ' to save ' + d.pct + '%', c / d.min); }
      });
      if (n > 0) { var l6 = six.min - n; row(six, false, 'Add ' + l6 + ' more ' + UNITS.six[l6 === 1 ? 0 : 1] + ' to save ' + six.pct + '% on everything', n / six.min); }
    }
    el.innerHTML = rows.length ? '<p class="sap-dp__h">Multi-buy</p><ul role="list">' + rows.join('') + '</ul>' +
      (cart.total_discount > 0 && cart.total_discount !== shown ? '<p class="sap-dp__total">Saving ' + esc(money(cart.total_discount)) + ' on this order</p>' : '') : '';
    el.hidden = !rows.length;
  }
  function fillSet(el, cart) {
    var cnt = dealCounts(cart), t = cnt.tees || 0, h = cnt.hoodies || 0;
    if (!t && !h) { el.hidden = true; return; }
    var handle = (t && !h) ? 'hoodies' : (h && !t) ? 'tees' : (t >= h ? 'hoodies' : 'tees');
    var inCart = cart.items.map(function (i) { return i.product_id; });
    fetch('/collections/' + handle + '/products.json?limit=12').then(function (r) { return r.json(); }).then(function (d) {
      var list = (d.products || []).filter(function (p) {
        return inCart.indexOf(p.id) < 0 && p.variants.some(function (v) { return v.available; });
      }).slice(0, 3);
      if (!list.length) { el.hidden = true; return; }
      el.innerHTML = '<p class="sap-dp__h">' + esc((SAP.strings && SAP.strings.completeSet) || 'Complete the set') + '</p><ul class="sap-set__list" role="list">' +
        list.map(function (p) {
          var img = p.images && p.images[0] ? sized(p.images[0].src, 200) : '';
          return '<li><a class="sap-set__item" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="90" loading="lazy">' : '') +
            '<span class="sap-set__t">' + esc(p.title) + '</span><span class="sap-set__p">' + esc(money(Math.round(parseFloat(p.variants[0].price) * 100))) + '</span></a></li>';
        }).join('') + '</ul>';
      el.hidden = false;
    }).catch(function () { el.hidden = true; });
  }
  var dealsTimer = null;
  function refreshDeals(force) {
    clearTimeout(dealsTimer);
    dealsTimer = setTimeout(function () {
      var els = qa('[data-sap-deals-progress]' + (force ? '' : ':not([data-filled])'));
      var sets = qa('[data-sap-set]' + (force ? '' : ':not([data-filled])'));
      if (!els.length && !sets.length) return;
      els.concat(sets).forEach(function (e) { e.setAttribute('data-filled', '1'); });
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (cart) {
        els.forEach(function (e) { fillDeals(e, cart); });
        sets.forEach(function (e) { fillSet(e, cart); });
      }).catch(function () { els.concat(sets).forEach(function (e) { e.removeAttribute('data-filled'); }); });
    }, 120);
  }
  SAP.refreshDeals = refreshDeals;
  SAP.fillDeals = fillDeals;
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { if (document.querySelector('[data-sap-deals-progress]:not([data-filled]),[data-sap-set]:not([data-filled])')) refreshDeals(); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshDeals(true); });
  } catch (e) {}

  /* ---------------- boot ---------------- */
  function init(scope) {
    applyGates(scope); initReveal(scope); initCircles(scope); initParallax(scope); initHeader(scope); initAnnounce(scope); initSliders(scope); initTabs(scope);
    initSlideshow(scope); initStickyVideo(scope); initLayers(scope); initHotspots(scope); initMarquee(scope);
    initRecent(scope); initRecs(scope); refreshDeals();
    requestScroll();
  }
  SAP.init = init;
  function boot() { init(document); window.SAPMotionReady = true; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  reduce.addEventListener && reduce.addEventListener('change', function () { if (reduce.matches) root.classList.remove('sap-motion'); });
})();
